<template lang="pug">
.main
  .ui.secondary.inverted.menu.nav.no-print(:class='{"mode-offline": !is_online, "mode-debug": is_debug}')
    router-link.item(:to="'/'").brand-logo.hide-in-mobile
      img.logo(src='/dist/logo.svg')
      branch-label(small)

    .item(v-show='!is_online')
      | 离线模式
      el-tooltip(content='当前处于离线模式，系统所呈现的数据可能与实际不一致，但你仍然可以查看已经离线的数据。', placement='top')
        i.icon.help.circle.semitrans
    router-link.item(to='/') 概况
    router-link.item(to='/bills', v-if='$permission.has("basic.view.bills")')
      | 收支
      .floating.ui.olive.mini.circular.label(v-if='false') {{0}}

    el-popover(ref='records', popper-class='menu', placement='bottom-start', width='200', trigger='click')
      .ui.fluid.vertical.menu
        router-link.item(to='/customers', v-if='$permission.has("basic.view.customers")') 住户
        router-link.item(to='/properties', v-if='$permission.has("basic.view.properties")') 仓库
        router-link.item(to='/charges', v-if='$permission.has("basic.view.charges")') 水电充值记录
        router-link.item(to='/records/meters', v-if='$permission.has("basic.record")') 公寓水电表记录

    .ui.dropdown.item(v-popover:records='')
      | 记录
      i.dropdown.icon

    el-popover(ref='reports', popper-class='menu', placement='bottom-start', width='200', trigger='click', v-if='$permission.has("basic.reports")')
      .ui.fluid.vertical.menu
        router-link.item(to='/reports', v-if='$permission.has("basic.reports.basic")') 基础信息
        router-link.item(to='/reports/meters', v-if='$permission.has("basic.reports.meters")') 公寓水电使用情况
        router-link.item(to='/reports/charges', v-if='$permission.has("basic.reports.charges")') 水电充值报表
        //router-link.item(to='/reports/month', v-if='$permission.has("basic.reports.month")') 月汇总报表
        router-link.item(to='/reports/summary', v-if='$permission.has("basic.reports.summary")') 年度汇总报表
        router-link.item(to='/reports/subjects', v-if='$permission.has("basic.reports.subjects")') 科目汇总报表
        router-link.item(to='/reports/utilities_monitor', v-if='$permission.has("basic.reports.utilities_monitor")') 水电监控

    .ui.dropdown.item.hide-in-mobile(v-if='$permission.has("basic.view.reports")', v-popover:reports='')
      | 报表
      i.dropdown.icon

    template(v-if='contract_draft_keys.length')
      el-popover(ref='contract_drafts', placement='bottom', width='400', trigger='click')
        .ui.relaxed.divided.list.draft-list
          .item(v-for='info in contract_draft_list')
            i.mi(@click='contract_draft_delete(info.key)') delete
            .header(@click='contract_draft_go(info.key)') {{info.no}}
            span(@click='contract_draft_go(info.key)') {{info.time}}

      a.item(v-popover:contract_drafts='')
        | 合同草稿
        .floating.ui.olive.mini.circular.label {{contract_draft_keys.length}}

    router-link.item.hide-in-mobile(to='/admin', v-if='$permission.has("system.admin")') 管理

    a.item(@click='refresh') 刷新

    .item.narrow: .ui.transparent.input.inverted.short(:class='{error:quick_nav_input_error}')
        input(v-model='quick_nav_input', type='text', placeholder='房间号...', @keydown.enter='quick_nav_go()')

    a.item.icon(v-show='$router.fullPath === "/"', @click='load_summary')
      i.icon.refresh

    el-popover(ref='profile', placement='bottom-end', width='250', trigger='click')
      .profile.ui.comments: .comment: .content
        a.author {{ $formatters.user_name($user) }}
        .text {{ $formatters.user_role($user) }}
        .actions
          a.logout(@click='logout') 登出
          router-link.profile(to='/profile') 信息

    .right.menu
      .item.hide-in-mobile(v-popover:profile='') {{ $formatters.user_name($user) }}
      a.item.icon(@click='logout')
        i.icon.sign.out

  .main-container
    .router-container
      router-view

</template>

<script>
import { BranchLabel } from '../components/basic'

const SESSION_TIMEOUT = 1000 * 60 * 3 // 3min

let registed = false
let timer = null

export default {
  name: 'main',
  components: { BranchLabel },
  created() {
    if (!registed) {
      const update_network_state = (event) => {
        this.is_online = window.navigator.onLine
      }

      window.addEventListener('online', update_network_state)
      window.addEventListener('offline', update_network_state)

      window.addEventListener('focus', () => {
        // console.log('Focused!')
        if (timer != null) {
          clearTimeout(timer)
          timer = null
        }
      })

      window.addEventListener('blur', () => {
        // console.log('Blur!')
        if (this.$route.path !== '/login') {
          timer = setTimeout(() => {
            // console.log('Timeout!')
            timer = null
            this.$router.$go.login({ redirect: this.$route.path, timeout: true })
          }, SESSION_TIMEOUT)
        }
      })
      registed = true
    }

    if (!this.$user.username)
      this.$router.$go.login()
    else
      this.load_summary()
  },
  data() {
    return {
      is_online: window.navigator.onLine,
      is_debug: process.env.NODE_ENV !== 'production',
      quick_nav_input: '',
      quick_nav_input_error: false,
    }
  },
  watch: {
    quick_nav_input() {
      this.quick_nav_input_error = false
    },
  },
  computed: {
    contract_draft_list() {
      const summarys = []
      for (const key of this.contract_draft_keys) {
        const parts = key.split('-')
        const no = parts[0]
        const raw = `${parts[1]}-${parts[2]}`
        const time = this.$moment(raw, 'YYYYMMDD-HHmmss').locale('zh-cn').fromNow()
        summarys.push({ key, no, time, raw })
      }
      return summarys
    },
    contract_draft_keys() {
      return this.$store.getters.draft('contracts').keys()
    },
    rooms() {
      return this.$store.state.summary.rooms
    },
  },
  methods: {
    load_summary(notify) {
      this.$store.dispatch('load_meta', this)
      this.$store.dispatch('load_summary', this)
        .then(() => {
          if (notify) {
            this.$message({
              message: '数据已更新',
              type: 'success',
              duration: 800,
            })
          }
        })
    },
    refresh() {
      if (this.is_online)
        this.load_summary(true)
      else
        window.location.reload()
    },
    goback() {
      this.$router.back()
    },
    contract_draft_go(key) {
      const no = key.split('-')[0]
      this.$router.push(`/room/${no}/sign/load/${key}`)
    },
    contract_draft_delete(key) {
      this.$store.commit('DRAFT_DELETE', { type: 'contracts', key })
    },
    quick_nav_go() {
      if (this.$router.$go.room({ no: this.quick_nav_input.trim() }))
        this.quick_nav_input = ''
      else
        this.quick_nav_input_error = true
    },
    logout() {
      this.$http.get('users/logout')
      this.$user.logout()
      this.$router.push('/login')
    },
  },
}
</script>



// WEBPACK FOOTER //
// Main.vue?5a62a747